export default "__VITE_ASSET__PP3JKhyR__"